import { ActionLogger } from 'businessCommon/src/services/log/actionLogger';
export enum LogAction {
    PLATFORM_CACHE_URL_DIFF = 'platform_cache_url_diff',
}
let actionLogger: ActionLogger | null = null;
export const logPlatformDiff = (urlValue: boolean, cacheValue: boolean) => {
    if (!actionLogger) {
        actionLogger = new ActionLogger({ tag: 'check_is_in_use', debug: true });
    }
    try {
        const logData = { urlValue, cacheValue, url: window.location.href };
        actionLogger.log(LogAction.PLATFORM_CACHE_URL_DIFF, logData);
    } catch (_error) {}
};
